// extracted by mini-css-extract-plugin
module.exports = {"faqSection":"ProFaqSection_faqSection__--T3v","faqSectionTitle":"ProFaqSection_faqSectionTitle__307tR","faqSectionContent":"ProFaqSection_faqSectionContent__2s-Kj"};